import { Controller } from "@animech/axiom-ui-builder/src/controller";
import { createContext } from "react";
import {
	Article,
	ApiDataManager,
	ApiExportData,
	ApiNotification,
} from "src/api/api-data-manager";
import { SessionData } from "src/core";

type ApiDataInterface = {
	guid: string;
	pricelistId: string | null;
	isLoading: boolean;
	apiNotification: ApiNotification | undefined;
	currency: string | undefined;
	countryCode: string | null;
	vat: string;
	articles: Article[];
	exportData: ApiExportData;
	openDesign: (designId: string) => Promise<boolean>;
	getSerializedConfiguration: () => SessionData;
	generateSnapshot: () => Promise<string>;
	addApiNotification: (apiNotification: ApiNotification | undefined) => void;
	setDesignId: (designId: string) => void;
	setName: (name: string) => void;
	setIsLoading: (isLoading: boolean) => void;
};

export const ApiDataContext = createContext<ApiDataInterface>(
	{} as ApiDataInterface,
);

export class ApiDataController extends Controller<ApiDataInterface> {
	constructor(onRender: () => void, apiDataManager: ApiDataManager) {
		super(ApiDataContext, {
			get isLoading(): boolean {
				return apiDataManager.isLoading;
			},
			get apiNotification(): ApiNotification | undefined {
				return apiDataManager.apiNotification;
			},
			get currency(): string {
				return apiDataManager.currency;
			},
			get countryCode(): string | null {
				return apiDataManager.countryCode;
			},
			get vat(): string {
				return apiDataManager.vat;
			},
			get articles(): Article[] {
				return apiDataManager.articles;
			},
			get exportData(): ApiExportData {
				return apiDataManager.exportData;
			},
			get guid(): string {
				return apiDataManager.guid;
			},
			get pricelistId(): string | null {
				return apiDataManager.pricelistId;
			},
			openDesign(designId: string) {
				return apiDataManager.openDesign(designId);
			},
			addApiNotification(apiNotification: ApiNotification | undefined) {
				apiDataManager.addApiNotification(apiNotification);
				onRender();
			},
			getSerializedConfiguration() {
				return apiDataManager.getSerializedConfiguration();
			},
			async generateSnapshot() {
				return await apiDataManager.generateSnapshot();
			},
			setDesignId(designId: string) {
				apiDataManager.setDesignId(designId);
			},
			setName(name: string) {
				apiDataManager.setDesignName(name);
			},
			setIsLoading(loading: boolean) {
				apiDataManager.setIsLoading(loading);
				onRender();
			},
		});
	}
}
